import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">ManPoints · Empowering Men's Voices</p>
        <h1>Welcome to ManPoints.</h1>
        <p className="lede">
          Join us in exploring the vital conversations around men's rights, lifestyle, and culture. 
          Our blog is dedicated to fostering a community where men's perspectives are valued and discussed.
        </p>
        <div className="cta-row">
          <a href="/about" target="_self">
            Learn More
          </a>
          <a href="/blog" target="_self" className="secondary">
            Read Our Articles
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engage with Relevant Topics</h2>
          <p>
            Dive into discussions that matter. From rights advocacy to lifestyle tips, we cover a range of subjects that resonate with men today.
          </p>
        </article>
        <article>
          <h2>Join a Supportive Community</h2>
          <p>
            Connect with like-minded individuals who share your interests and concerns. Together, we can amplify our voices and drive change.
          </p>
        </article>
        <article>
          <h2>Stay Informed and Inspired</h2>
          <p>
            Our articles are designed to inform and inspire. Stay updated on the latest trends and insights in men's culture and lifestyle.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;